import { render, staticRenderFns } from "./CodingAdd.vue?vue&type=template&id=6bd8fc20&scoped=true"
import script from "./CodingAdd.vue?vue&type=script&lang=js"
export * from "./CodingAdd.vue?vue&type=script&lang=js"
import style0 from "./CodingAdd.vue?vue&type=style&index=0&id=6bd8fc20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd8fc20",
  null
  
)

export default component.exports